module.exports = __webpack_public_path__ + "static/media/mob-conan-main.45e82ab8.jpg";